<template>
  <header class="layout-header">
    <div class="logo">
      <router-link to="/" class="logo__img"></router-link>
      <router-link to="/" class="logo__title">{{ msg }}</router-link>
    </div>
    <gl-layout-user :user-name="userName" :actives="actives"></gl-layout-user>
  </header>

</template>

<script>
import GlLayoutUser from './User'

export default {
  name: 'GlLayoutHeader',
  componentName: 'GlLayoutHeader',
  props: {
    msg: String,
    userName: String,
    actives: Object
  },
  components: {
    GlLayoutUser
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue